var exports = {
  "n": "xf0b3b88a--3c6ba5--deadline",
};

module.exports = exports;
